package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.designs.DesignsCatalogueSection
import com.anjuros.website.redesign.sections.designs.DesignsFaqSection
import com.anjuros.website.redesign.sections.designs.DesignsGuideSection
import com.anjuros.website.redesign.sections.designs.DesignsHeroSection
import com.anjuros.website.redesign.sections.designs.DesignsIncludedSection
import com.anjuros.website.redesign.sections.designs.DesignsNextStepSection
import com.anjuros.website.redesign.sections.designs.designsStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun WebsiteTemplatesUk() {
    val title = LocalText(RdText.DESIGNS_META_TITLE)
    val description = LocalText(RdText.DESIGNS_META_DESCRIPTION)
    val structuredData = designsStructuredData()

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.DESIGNS}")
        setJsonLd("ld-designs", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.DESIGNS))
        Main {
            DesignsHeroSection()
            DesignsIncludedSection()
            DesignsCatalogueSection()
            DesignsGuideSection()
            DesignsFaqSection()
            DesignsNextStepSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
